<template>
  <div class="fts-grid-view">

    <div v-for="item in list" class="grid-view" :key="item.id">
      <div class="grid-view-wrapper">
        <div class="grid-view-header">
          header
        </div>

        <div class="grid-view-content" style="display: flex;flex-wrap: wrap;">
          
          <!-- <div v-for="column in getColumns" :key="column.id" style="margin: .375rem;" :class="{ 'full-width': column.type === 14 }"> 
            <fts-list-view-display
              class="card-view-content-display fts-scrollbar"
              :formData="item.extension"
              :item="column"
              mode="comfort"
            />
          </div> -->

        </div>


        <div class="grid-view-footer">
          footer
        </div>
      </div>
    </div>


  </div>
</template>

<script>

import moment from "moment";
import commons from "../commons/commons";

import FTSListViewDisplay from "./FTSListViewDisplay";
import FTSStandardMenu from "./FTSStandardMenu";

export default {
  props: {
    columns: {
      type: Array,
      default: function() {
        return [];
      }
    },
    list: {
      type: Array,
      default: function() {
        return [];
      }
    },
  },
  components: {
    "fts-list-view-display": FTSListViewDisplay,
    "fts-standard-menu": FTSStandardMenu
  },

  data() {
    return {
      list: [
        {name: '1'},{name: '2'},{name: '3'},{name: '4'},{name: '5'},
        {name: '6'},{name: '7'},{name: '8'},{name: '9'},{name: '0'}
      ]
    }
  },
  methods: {

  },
  computed: {
    getColumns() {
      return this.columns.filter(item => {
        return (
          item.fieldName &&
          item.fieldName != "documentId" &&
          item.fieldName != "state.name" &&
          !item.system
        );
      });
    }
  }
}
</script>

<style lang="scss" scoped>
@import "./src/assets/scss/vars.scss";

.fts-grid-view {
  column-gap: 0;
  row-gap: 0;

  // column-gap: 1rem;
  @media (max-width: 992px) {
    columns: 1;
  }
  @media (min-width: 992px) and (max-width: 1200px) {
    columns: 2;
  }
  @media (min-width: 1200px) and (max-width: 1680px) {
    columns: 3;
  }
  @media (min-width: 1680px) {
    columns: 4;
  }

  .grid-view {
    -webkit-column-break-inside: avoid;
    page-break-inside: avoid;
    -moz-column-break-inside: avoid;
    break-inside: avoid;

    align-items: center;
    justify-self: center;
    padding: 1rem;

    .grid-view-wrapper {
      break-inside: avoid-column;
      border-radius: 5px;
      background: rgba(255, 255, 255, 0.95);
    }
    
  }

}

</style>